import { createSelector } from 'reselect';

const assetAllocationReport = state => state.assetAllocationReport;

export const hasLoadedSelector = createSelector(
  assetAllocationReport,
  ({ hasLoaded }) => hasLoaded,
);

export const errorTypesSelector = createSelector(
  assetAllocationReport,
  ({ errorType }) => errorType,
);

export const errorsSelector = createSelector(assetAllocationReport, ({ errors }) => errors);

export const selectedPivotSelector = createSelector(
  assetAllocationReport,
  ({ SelectedPivot }) => SelectedPivot,
);

export const selectedFiltersPivotSelector = createSelector(
  assetAllocationReport,
  ({ SelectedFilters }) => SelectedFilters,
);

export const reportOptionsSelector = createSelector(
  assetAllocationReport,
  ({ ReportOptions }) => ReportOptions,
);

export const isDetailedShowingSelector = createSelector(
  assetAllocationReport,
  ({ isDetailedShowing }) => isDetailedShowing,
);

export const reportDataSelector = createSelector(
  assetAllocationReport,
  ({ isDetailedShowing, ReportData }) => {
    const { Current, Recommended } = ReportData;
    const { ADV } = window;

    if (isDetailedShowing) {
      return {
        current: {
          ...Current,
          ...ADV.util.chart.parseAllocationSeries(
            Current.ChartDataDetailed,
          ),
        },
        recommended: {
          ...Recommended,
          ...ADV.util.chart.parseAllocationSeries(
            Recommended.ChartDataDetailed,
          ),
        },
      };
    }

    return {
      current: {
        ...Current,
        ...ADV.util.chart.parseAllocationSeries(
          Current.ChartData,
        ),
      },
      recommended: {
        ...Recommended,
        ...ADV.util.chart.parseAllocationSeries(
          Recommended.ChartData,
        ),
      },
    };
  },
);
